import { UserData, useUsers } from '@hooks';
import { Modal } from 'antd';

interface DeleteUserModalProps {
  open: boolean;
  onCancel: () => void;
  user: UserData | null;
  onSuccess?: () => void;
}

export const DeleteUserModal = ({ open, onCancel, user, onSuccess }: DeleteUserModalProps) => {
  const { deleteUser } = useUsers();

  const handleDelete = async () => {
    if (!user) return;

    try {
      await deleteUser.mutateAsync(user.id);
      onCancel();
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error('Error deleting user:', error);
    }
  };

  return (
    <Modal
      title={<span className="font-displayed !font-normal text-orangicide text-3xl">CONFIRM DELETE</span>}
      open={open}
      onOk={handleDelete}
      onCancel={onCancel}
      confirmLoading={deleteUser.isPending}
      okText="Yes, delete"
      cancelText="Cancel"
      okButtonProps={{
        className: 'font-displayed !font-normal btn-orangicide !text-lg'
      }}
      cancelButtonProps={{
        className: 'font-displayed !font-normal btn-orangicide !text-lg'
      }}
      className="[&_.ant-modal-content]:!bg-zinc-800 [&_.ant-modal-content]:!text-white [&_.ant-modal-header]:!bg-zinc-800 [&_.ant-modal-header]:!border-b-zinc-700"
    >
      <p className="font-orator text-lg uppercase py-2">
        Are you sure you want to delete the user <strong>{user?.physicalPerson?.name || user?.email}</strong>? This action cannot be undone.
      </p>
    </Modal>
  );
};
